export function getLocalStorage(key: string, defaultValue?: any) {
  if (typeof localStorage === "undefined") return defaultValue;
  const value = localStorage.getItem(key);
  if (null === value) return defaultValue;

  try {
    return JSON.parse(value);
  } catch (error) {
    console.warn("Unexpected localStorage value", key, value);
    return value;
  }
}

export function setLocalStorage(key: string, value?: any) {
  return undefined !== value && null !== value
    ? localStorage.setItem(key, JSON.stringify(value))
    : removeLocalStorage(key);
}

export function removeLocalStorage(key: string) {
  return localStorage.removeItem(key);
}

export function getSessionStorage(key: string, defaultValue?: any) {
  if (typeof sessionStorage === "undefined") return defaultValue;

  const value = sessionStorage.getItem(key);
  if (null === value) return defaultValue;

  try {
    return JSON.parse(value);
  } catch (error) {
    console.warn("Unexpected sessionStorage value", key, value);
    return value;
  }
}

export function setSessionStorage(key: string, value?: any) {
  return undefined !== value && null !== value
    ? sessionStorage.setItem(key, JSON.stringify(value))
    : removeSessionStorage(key);
}

export function removeSessionStorage(key: string) {
  return sessionStorage.removeItem(key);
}
